import { createFileRoute } from '@tanstack/react-router';
import { Heading } from 'components/Heading';
import { MobileScreen } from 'components/MobileScreen';
import { emitMessage, useOnline, useVersion } from 'engine/api';
import { isTauri } from '@tauri-apps/api/core';
import { type } from '@tauri-apps/plugin-os';
import { useEffect, useState } from 'react';
import { shouldUseNativeGPS } from 'engine/lib';
import { Button } from 'components/Button';
import { useStore } from 'engine/store';

const isNative = isTauri(); // true if iOS or Android
const osType = isNative ? type() : 'web';

export const Route = createFileRoute('/debug')({
	component: RouteComponent,
});

function RouteComponent() {
	const [props, setProps] = useState({});
	const version = useVersion();
	const [usingNativeGps, setUsingNativeGps] = useState(false);
	const [hasSentState, setHasSentState] = useState(false);
	const online = useOnline();
	useEffect(() => {
		shouldUseNativeGPS().then(setUsingNativeGps);
		let buildDate = 'unknown';
		let viteAppVersion = 'unknown';

		try {
			buildDate = __BUILD_DATE__;
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (e) {
			/* empty */
		}
		try {
			viteAppVersion = __APP_VERSION__;
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (e) {
			/* empty */
		}

		console.log('vite vars', buildDate, viteAppVersion);

		setProps({
			Native: isTauri() ? 'yes' : 'no',
			online: online ? 'yes' : 'no',
			OS: osType,
			AppVersion: version?.semVer || 0,
			userAgent: navigator.userAgent,
			'Gps type': usingNativeGps ? 'native' : 'web',
			'Web build date': buildDate,
			'Web version': viteAppVersion,
		});
	}, [version?.semVer, usingNativeGps, online]);

	const SendState = () => {
		try {
			console.log('try sending debug state');
			setHasSentState(true);
			const state = useStore.getState();
			const debugInfo = { ...props };
			emitMessage({
				kind: 'debug-state',
				debug: debugInfo,
				state,
				teamId: state.teamId ?? 'undefined',
				eventId: state.eventId ?? 'undefined',
				deviceId: state.deviceId ?? 'undefined',
				time: Date.now(),
			})
				.then((r) => console.log(`Debug info sent`, r))
				.catch((err) => console.warn(`Error sending debug state info`, err));
		} catch (error) {
			console.warn(`Error getting debug state info`, error);
		}
	};

	return (
		<MobileScreen className="flex flex-col gap-4">
			<Heading mode="secondary">Debug</Heading>
			<div className="flex flex-col gap-2">
				{Object.entries(props as Record<string, string | number | boolean>).map(([key, value]) => {
					return (
						<span key={key}>
							<strong>{key}:</strong> {value}
						</span>
					);
				})}
			</div>
			<div className="flex flex-col gap-2">
				<Button onClick={() => SendState()} disabled={hasSentState}>
					Send State
				</Button>
			</div>
		</MobileScreen>
	);
}
